export default __webpack_public_path__ + "static/media/ig-icon.46f37551.svg";